// extracted by mini-css-extract-plugin
module.exports = {"label":"Label_label__2hUCb","required":"Label_required__3e-TQ","optional":"Label_optional__jFg0z"};